function first(pair) {
    return pair[0];
}
function second(pair) {
    return pair[1];
}
export const state = first;
export const result = second;
function mkPair(a, b) {
    return [a, b];
}
export class TimeBox {
    constructor(runBox) {
        this.runBox = runBox;
    }
}
export const mkTimebox = (p) => new TimeBox(p);
export const runTimeBox = (current) => (state) => second(current.runBox(state));
export const evalTimeBox = (current) => (state) => first(current.runBox(state));
export function map(current, fn) {
    return new TimeBox((state) => {
        const timestamp = runTimeBox(current)(state);
        return [state, fn(timestamp)];
    });
}
export const mapC = (fn) => (current) => {
    return new TimeBox((state) => {
        const timestamp = runTimeBox(current)(state);
        return [state, fn(timestamp)];
    });
};
export function mapState(current, fn) {
    return new TimeBox((state) => {
        const [s, v] = current.runBox(state);
        return [s, fn(s, v)];
    });
}
export const mapStateC = (fn) => (current) => {
    return new TimeBox((state) => {
        const [s, v] = current.runBox(state);
        return [s, fn(s, v)];
    });
};
export function combine(current, objFn) {
    return new TimeBox((state) => {
        const [s, v] = current.runBox(state);
        const res = Object.keys(objFn).reduce((acc, key) => {
            return Object.assign(Object.assign({}, acc), { [key]: result(objFn[key](current).runBox(state)) });
        }, {});
        return [s, res];
    });
}
export const combineC = (objFn) => (current) => {
    return new TimeBox((state) => {
        const [s, v] = current.runBox(state);
        const res = Object.keys(objFn).reduce((acc, key) => {
            return Object.assign(Object.assign({}, acc), { [key]: result(objFn[key](current).runBox(state)) });
        }, {});
        return [s, res];
    });
};
export function chain(current, fn) {
    return mkTimebox((state) => {
        const x = runTimeBox(current)(state);
        const d = runTimeBox(fn(x))(state);
        return mkPair(state, d);
    });
}
export const chainC = (fn) => (current) => {
    return mkTimebox((state) => {
        const x = runTimeBox(current)(state);
        const d = runTimeBox(fn(x))(state);
        return mkPair(state, d);
    });
};
export function dimap(current, fn1, fn2) {
    return new TimeBox((state) => {
        const s1 = fn2(state);
        const timestamp = runTimeBox(current)(s1);
        return [state, fn1(timestamp)];
    });
}
export function initializeTimebox() {
    return mkTimebox((state) => [state, state.timestamp]);
}
